import React, { useContext, useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { Table } from "react-bootstrap"
import UsuarioContext from "../Context/Usuario"
import Loading from "../Utils/Loading"
import { Scatter } from "react-chartjs-2"

const PerfilEgresoCohorte = (props) => {
  const [datosPerfilEgreso, setDatosPerfilEgreso] = useState(null)
  const { usuario } = useContext(UsuarioContext)
  const params = useParams()

  useEffect(() => {
    if (!params || !params.cohorteid) {
      return
    }
    let cohorte = usuario.cohortes[params.cohorteid]
    if (!cohorte) {
      setDatosPerfilEgreso(undefined)
      return
    }
    if (!cohorte.datos_perfil_egreso) {
      console.log(cohorte)
      setDatosPerfilEgreso(undefined)
      return
    }
    let parsed = JSON.parse(cohorte.datos_perfil_egreso)
    console.log(parsed)
    setDatosPerfilEgreso(parsed)
  }, [props])

  if (datosPerfilEgreso === undefined) {
    return <div>Cohorte no tiene datos de Perfil de Egreso</div>
  }

  if (!datosPerfilEgreso) {
    return <Loading />
  }

  const rand = () => Math.round(Math.random() * 20 - 10)

  const data = {
    datasets: [
      {
        label: "A dataset",
        data: [
          { x: rand(), y: rand() },
          { x: rand(), y: rand() },
          { x: rand(), y: rand() },
          { x: rand(), y: rand() },
          { x: rand(), y: rand() },
          { x: rand(), y: rand() },
          { x: rand(), y: rand() },
          { x: rand(), y: rand() },
          { x: rand(), y: rand() },
          { x: rand(), y: rand() },
          { x: rand(), y: rand() },
          { x: rand(), y: rand() },
          { x: rand(), y: rand() },
          { x: rand(), y: rand() },
        ],
        backgroundColor: "rgba(255, 99, 132, 1)",
      },
    ],
  }

  const options = {
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
        },
      ],
    },
  }
  let tasa = 0
  if (datosPerfilEgreso.length > 0) {
    tasa =
      datosPerfilEgreso.filter((p) => {
        return p.perfil_ingreso && p.perfil_actual
      }).length / datosPerfilEgreso.length
    tasa = (tasa * 100).toFixed(0)
  }

  return (
    <>
      <h4>Tasa de completitud: {tasa}%</h4>
      <Scatter data={data} options={options} />
      <Table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Ingreso</th>
            <th>Actual</th>
          </tr>
        </thead>
        <tbody>
          {datosPerfilEgreso.map((perfil, idx) => {
            return (
              <tr key={idx}>
                <td>{perfil.id_string}</td>
                <td>{perfil.perfil_ingreso}</td>
                <td>{perfil.perfil_actual}</td>
              </tr>
            )
          })}
        </tbody>
      </Table>
    </>
  )
}

export default PerfilEgresoCohorte
